import { getTermsValue } from '@/packages/JsonQuery';
import { ERepair } from '@/packages/api-models/common/json_query';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagRepairSchema } from '../types';

const TEXT_MAP: { [key in ERepair]: string } = {
  [ERepair.Cosmetic]: 'Косметический ремонт',
  [ERepair.Design]: 'Дизайнерский ремонт',
  [ERepair.Euro]: 'Евроремонт',
  [ERepair.Without]: 'Без ремонта',
};

export const repair: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermsValue('repair')(jsonQuery) || [];

    const tagsGroup: TagRepairSchema[] = value.map(key => ({
      group: 'repair',
      text: TEXT_MAP[key],
      data: key,
    }));

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagRepairSchema) {
    const currentValue = getTermsValue('repair')(jsonQuery) || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setRepair',
      arguments: [nextValue],
    });
  },
};
